module.exports = __webpack_public_path__ + "static/img/report_bg1.d1f5f6bd.png";